<template>
  <div class="container">
    <div v-for="(ponto, index) in pontosProcesso" :key="index">
      <span v-if="ponto.type == 'TANQUE'">
        <Reservatorio
          :Type="ponto.type"
          :ID="ponto.id"
          :Max="ponto.max_reservatorio"
          :Res="ponto.value"
          :Nome="ponto.nome_ponto"
          :Top="ponto.sup_top"
          :Left="ponto.sup_left"
          :Height="ponto.height"
          :Width="ponto.width"
          :Angle="ponto.sup_angle"
          :Enabled="false"
        />
      </span>
      <span v-else-if="ponto.type == 'BOMBA'">
        <Bomba
          :ID="ponto.id"
          :Nome="ponto.nome_ponto"
          :Status="ponto.value"
          :Top="ponto.sup_top"
          :Left="ponto.sup_left"
          :Height="ponto.height"
          :Width="ponto.width"
          :Angle="ponto.sup_angle"
          :Enabled="false"
        />
      </span>
      <span v-else-if="ponto.type == 'BOMBA_POCO'">
        <BombaPoco
          :ID="ponto.id"
          :Nome="ponto.nome_ponto"
          :Status="ponto.value"
          :Top="ponto.sup_top"
          :Left="ponto.sup_left"
          :Height="ponto.height"
          :Width="ponto.width"
          :Angle="ponto.sup_angle"
          :Enabled="false"
        />
      </span>
      <span v-else-if="ponto.type == 'CONTATO'">
        <Reservatorio
          :ID="ponto.id"
          :Max="ponto.max_reservatorio"
          :Res="ponto.value"
          :Nome="ponto.nome_ponto"
          :Top="ponto.sup_top"
          :Left="ponto.sup_left"
          :Height="ponto.height"
          :Width="ponto.width"
          :Angle="ponto.sup_angle"
          :Enabled="false"
        />
      </span>
      <span v-else-if="ponto.type == 'CANO'">
        <Cano
          :ID="ponto.id"
          :Res="ponto.value"
          :Nome="ponto.variable"
          :Top="ponto.sup_top"
          :Left="ponto.sup_left"
          :Height="ponto.height"
          :Width="ponto.width"
          :Angle="ponto.sup_angle"
          :Enabled="false"
        />
      </span>
      <span v-if="ponto.type == 'JUNCAOL'">
        <Juncao
          :ID="ponto.id"
          :Nome="ponto.variable"
          :Max="ponto.max_reservatorio"
          :Res="ponto.value"
          :Top="ponto.sup_top"
          :Left="ponto.sup_left"
          :Height="ponto.height"
          :Width="ponto.width"
          :Angle="ponto.sup_angle"
          :Type="ponto.type"
          :Enabled="false"
        />
      </span>
      <span v-if="ponto.type == 'JUNCAOT'">
        <Juncao
          :ID="ponto.id"
          :Nome="ponto.variable"
          :Max="ponto.max_reservatorio"
          :Res="ponto.value"
          :Top="ponto.sup_top"
          :Left="ponto.sup_left"
          :Height="ponto.height"
          :Width="ponto.width"
          :Angle="ponto.sup_angle"
          :Type="ponto.type"
          :Enabled="false"
        />
      </span>

      <span v-if="ponto.type == 'DISTRIBUICAO'">
        <Distribuicao
          :ID="ponto.id"
          :Nome="ponto.variable"
          :Max="ponto.max_reservatorio"
          :Res="ponto.value"
          :Top="ponto.sup_top"
          :Left="ponto.sup_left"
          :Height="ponto.height"
          :Width="ponto.width"
          :Angle="ponto.sup_angle"
          :Type="ponto.type"
          :Enabled="false"
        />
      </span>
    </div>

    <div v-if="pontosProcesso != null && pontosProcesso.length > 0">
      <span>
        <Caixa
          ID="ETAS"
          Titulo=""
          Top="300"
          Left="1020"
          Height="200"
          Width="990"
          Angle="0"
          Classe="yellow lighten-5"
          Index="-1"
          :Enabled="false"
        />
      </span>
      <span>
        <Caixa
          ID="CAPTACAO"
          Titulo="CAPTAÇÃO RIO MACHADO"
          Top="161"
          Left="60"
          Height="77"
          Width="178"
          Angle="90"
          :Enabled="false"
        />
      </span>
      <span>
        <Caixa
          ID="ETA2"
          Titulo="ETA2"
          Top="158"
          Left="233"
          Height="175"
          Width="134"
          Angle="0"
          :Enabled="false"
        />
      </span>
    </div>
  </div>
</template>

<script>
import Reservatorio from "../components/Reservatorio.vue";
import Bomba from "../components/Bomba.vue";
import Cano from "../components/Cano.vue";
import Juncao from "../components/Juncao.vue";
import Caixa from "../components/Caixa.vue";
import Distribuicao from "../components/Distribuicao.vue";
import datas from "../services/datas";

export default {
  /* eslint no-console: ["error", { allow: ["info", "warn", "error"] }] */
  name: "Main",
  components: {
    Reservatorio,
    Bomba,
    Cano,
    Juncao,
    Caixa,
    Distribuicao
  },
  props: {
    img: String
  },
  data: function() {
    return {
      pontosProcesso: JSON.parse(window.localStorage.getItem("pontosProcesso")),
      loop: null
    };
  },
  methods: {
    listarPontos() {
      let d = new Date();
      datas
        .listar("tabPage1")
        .then(response => {
          this.pontosProcesso = response.data;
          window.localStorage.setItem(
            "pontosProcesso",
            JSON.stringify(response.data)
          );
          //Salva a data do cache
          window.localStorage.setItem(
            "cacheTime",
            `${d.toLocaleDateString()} ${d.toLocaleTimeString()}`
          );
          //Salva a data no vuex
          this.$store.commit(
            "setTime",
            window.localStorage.getItem("cacheTime")
          );
        })
        .catch(error => {
          console.warn(`Falha ao consumir a API!\n${error}`);
        });
    }
  },
  mounted() {
    this.$store.commit("setTime", window.localStorage.getItem("cacheTime"));
    this.listarPontos();
    clearInterval(this.loop);
    this.loop = setInterval(() => {
      this.listarPontos();
    }, 1000 * 15);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style></style>
